<div
  class="flex md:flex-row flex-col justify-start md:items-center md:space-x-8 md:py-8 gap-y-2 md:gap-y-0"
>
  <div
    class="flex md:basis-full md:flex-shrink md:justify-stretch md:items-center md:flex-row flex-col md:space-x-2 md:space-y-0 space-y-2"
    [formGroup]="form"
  >
    <mat-form-field class="w-full">
      <mat-label>Filter by</mat-label>
      <mat-select formControlName="filterBy">
        <mat-option [value]="null">None</mat-option>
        <mat-option value="product">Product</mat-option>
        <mat-option value="category">Category</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label *ngIf="form.value.filterBy"
        >Select {{ form.value.filterBy }}</mat-label
      >
      <mat-select
        [disabled]="form.value.filterBy === null"
        formControlName="filterId"
      >
        <mat-option [value]="null"></mat-option>
        <mat-option
          *ngFor="let option of options$ | async"
          [value]="option.id"
          >{{ option.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Labour cost per hour</mat-label>
      <span matPrefix [appAddCurrencyPrefix]="null"></span>
      <input type="number" matInput formControlName="labourCost" />
    </mat-form-field>
  </div>
  <button mat-flat-button color="primary" disabled="true">Export</button>
  <button mat-flat-button color="primary" (click)="generateReport()">
    Generate
  </button>
</div>
